export class PairingSecrets {
  pairingId: string;
  pairingCode: string;

  constructor(pairingId: string, pairingCode: string) {
    this.pairingId = pairingId;
    this.pairingCode = pairingCode;
  }
}
